import styled from 'styled-components';
import { PALETTE_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 77px);
    flex-shrink: 0;

    width: 100%;
    padding: 30px 30px 10px;
  `,
    LayoutSection: styled.div `
    display: grid;
    grid-template-columns: 1;
    row-gap: 25px;

    width: 100%;
    padding: 30px 0;

    border-bottom: ${(props) => props.isLast ? 'none' : `0.5px solid ${PALETTE_COLORS.PRIMARY_900}`};
  `,
    Title: styled.div `
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 500;
  `,
    Gap: styled.div `
    width: 100%;
    height: ${(props) => `${props.height}px`};
  `,
    LineButton: styled.a `
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: fit-content;

    border-radius: 10px;
    background: #00b900;
  `,
    Img: styled.img `
    width: 100%;
    border: 2px solid ${PALETTE_COLORS.NEUTRAL_900};
  `,
};
